module.exports = __webpack_public_path__ + "static/img/img-kf2.3dc19ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-kf2.png
// module id = 8xVe
// module chunks = 0